/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { ResearchChatControllerGetSessionQueryResponse, ResearchChatControllerGetSessionPathParams, ResearchChatControllerGetSession400, ResearchChatControllerGetSession401, ResearchChatControllerGetSession403, ResearchChatControllerGetSession404, ResearchChatControllerGetSession409, ResearchChatControllerGetSession500 } from "../types/ResearchChatControllerGetSession.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getResearchChatControllerGetSessionUrl(sessionId: ResearchChatControllerGetSessionPathParams["sessionId"]) {
  const res = { method: 'GET', url: `/api/research-chat/${sessionId}` as const }
  return res
}

/**
 * @description Retrieves the complete chat session including all messages and their citations.
 * @summary Get session with all messages
 * {@link /api/research-chat/:sessionId}
 */
export async function researchChatControllerGetSession(sessionId: ResearchChatControllerGetSessionPathParams["sessionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ResearchChatControllerGetSessionQueryResponse, ResponseErrorConfig<ResearchChatControllerGetSession400 | ResearchChatControllerGetSession401 | ResearchChatControllerGetSession403 | ResearchChatControllerGetSession404 | ResearchChatControllerGetSession409 | ResearchChatControllerGetSession500>, unknown>({ method : "GET", url : getResearchChatControllerGetSessionUrl(sessionId).url.toString(), ... requestConfig })
  return res.data
}